import React from "react";

import UiPopupAIContentFeatureGroups from "./UiPopupAIContentFeatureGroups";
import UiPopupAIContentPrompts from "./UiPopupAIContentPrompts";
import UiPopupAIContentMainPrompt from "./UiPopupAIContentMainPrompt";
import UiPopupAIContentToggleAllGroupsCheckbox from "./UiPopupAIContentToggleAllGroupsCheckbox";
import {SQFT_AI_PROMPT_TYPE} from "../aiPromptTypesConstants";

/**
 * "SQFT AI Management" tab - a single prompt slot on the current tool (getCommonVisualizerType(),
 * same as the AI Management tab) with type "SqftAI". It reuses the same three components as a
 * prompt on the first tab, so it gets the same versioning (add / clone / delete a version, the
 * selected one saved as the default by the popup's Save button) and the same feature group rows
 * with their prompt parts, enabled and Send Thumbnail checkboxes.
 *
 * Nothing here feeds the image render - these prompts exist for the SQFT Calculator to read.
 */
const UiPopupAIContentSqftAI = () => {
  return (
    <div>
      <div className="product-actions__title u-mb-1 u-mt-0 flex flex--center flex--between">
        <span className="flex-1 text-left bold scart-block__list-item-text-title">01. Select SQFT AI Prompt</span>
        <UiPopupAIContentToggleAllGroupsCheckbox/>
      </div>
      <div className="flex flex--center flex--between u-mb-1" style={{height: "420px"}}>
        <div className="u-pr-05 u-h-full" style={{width: "220px"}}>
          <UiPopupAIContentPrompts type={SQFT_AI_PROMPT_TYPE}/>
        </div>
        <div className="u-pl-05 u-pr-05 flex flex--1 flex--center flex--column u-h-full">
          <UiPopupAIContentMainPrompt type={SQFT_AI_PROMPT_TYPE} title="SQFT AI"/>
        </div>
        <div className="u-pl-05 u-pr-05 u-h-full flex--1">
          <UiPopupAIContentFeatureGroups type={SQFT_AI_PROMPT_TYPE}/>
        </div>
      </div>
    </div>
  )
};

export default UiPopupAIContentSqftAI
